// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-zoomer-gallery[data-v-31d37d68]{position:relative;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;user-select:none;min-width:100px;min-height:100px}.vue-zoomer-gallery>*[data-v-31d37d68]{display:inline-block}.vue-zoomer-gallery.anim .slide[data-v-31d37d68]{transition:left .4s}.slide[data-v-31d37d68]{position:absolute;top:0;-o-object-fit:contain;object-fit:contain;width:100%;height:100%;-webkit-user-drag:none}", ""]);
// Exports
module.exports = exports;
